module.exports = __webpack_public_path__ + "img/postcard-motive-placeholder.286d69ea.png";